import { NgModule } from '@angular/core';
import { SdvorPaymentsModule } from './payments/payments.module';

@NgModule({
  imports: [SdvorPaymentsModule],
})
export class SdvorPaymentUiModule {}
